import React, { useEffect, useState } from "react";
import axiosInstance from "../../utils/axiosApi";
import "../KeycloakLoginForm/LoginForm.css";
import axios from 'axios';
const LoginForm = () => {
  const [scimUsername, setScimUsername] = useState("");
  const [password, setPassword] = useState("");
  // const [loginFailed, setLoginFailed] = useState(false);

  // useEffect(() => {
  //   localStorage.clear();
  //   setLoginFailed(false);
  // }, []);

  // const handleSubmit = async (event) => {
  //   event.preventDefault();
  //   try {
  //     const response = await axiosInstance.post("token/obtain/", {
  //       scim_username: scimUsername,
  //       password: password,
  //     });

  //     // Wijzig de default Authorization-header zodat deze de verkregen JWT access-token bevat
  //     axiosInstance.defaults.headers["Authorization"] =
  //       "JWT " + response.data.access;

  //     // Sla de access- en refreshtokens op in de lokale opslag
  //     localStorage.setItem("access_token", response.data.access);
  //     localStorage.setItem("refresh_token", response.data.refresh);

  //     // Sla de e-mail van de ingelogde user op
  //     localStorage.setItem("current_user", scimUsername);

  //     window.location = "/app/";
  //     return response;
  //   } catch (error) {
  //     this.setState({
  //       loginFailed: true,
  //     });
  //     alert("Inloggen mislukt");
  //     setLoginFailed(true);
  //     throw error;
  //   }
  // };
//----------------------- Sher experimental login area----------------------------------

  const handleSubmit = async (event) => {
    // event.preventDefault();
    // window.location = "http://20.126.131.185:8080/realms/master/protocol/openid-connect/auth?client_id=pos_client_id&redirect_uri=http%3A%2F%2Flocalhost%3A8000%2Fapi%2Fusers%2F&scope=openid&response_type=token&response_mode=form_post&state=ba21ylopoxp&nonce=mzgii58u9gb"
    // window.location = "http://20.126.131.185:8080/realms/master/protocol/openid-connect/auth?client_id=pos_client_id&redirect_uri=http%3A%2F%2Flocalhost%3A3000%2Fapp%2Fpanden&scope=openid&response_type=token&response_mode=form_post&state=ba21ylopoxp&nonce=mzgii58u9gb"

    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: 'https://www.google.com',
      headers: { }
    };
    
    axios.request(config)
    .then((response) => {
      console.log(JSON.stringify(response.data));
    })
    .catch((error) => {
      console.log(error);
    });
    
  };
//---------------------------------------------------------
  return (
    <div>
      <br />
      <form onSubmit={handleSubmit} className="box" id="login-form">
        <h1 className="title">Inloggen</h1>
        {/* <h2
          className="subtitle"
          style={{ display: loginFailed ? "block" : "none" }}
        >
          Verkeerde combinatie
        </h2> */}
        <div className="field">
          <p className="control has-icons-left has-icons-right">
            <input
              name="username"
              className="input"
              onChange={(e) => setScimUsername(e.target.value)}
              // type="email"
              placeholder="Username"
              required={true}
            />
            <span className="icon is-small is-left">
              <i className="fas fa-envelope"></i>
            </span>
          </p>
        </div>
        <div className="field">
          <p className="control has-icons-left">
            <input
              name="password"
              className="input"
              onChange={(e) => setPassword(e.target.value)}
              type="password"
              placeholder="Password"
              required={true}
            />
            <span className="icon is-small is-left">
              <i className="fas fa-lock"></i>
            </span>
          </p>
        </div>
        <div className="field">
          <p className="control">
            <button className="button is-primary is-outlined">Login</button>
          </p>
        </div>
      </form>
    </div>
  );
};

export default LoginForm;
